import React from 'react';
import chLeft from '../../images/chevronLeft.svg';
import chRight from '../../images/chevronRight.svg';
import styles from './RiskPotential.css';

import Card from '../../components/Card/Card';
import { CARD_NAMES } from '../../utils/constants';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';
import ErrorMessageNewFund from '../../components/ErrorMessages/ErrorMessageNewFund';
import { RISK_LEVEL } from './queries';
import { riskPotentialUtil, getRiskDisclaimer, trpTickerOverLap } from './util';

class RiskPotential extends React.Component {
    state = {
        currentGrade: null
    };

    render() {
        const { ticker } = this.props;
        const { currentGrade } = this.state;

        const scrollDir = (dir, level) => {
            if (dir === 'prev') {
                this.setState({
                    currentGrade: level === 1 ? 10 : level - 1
                });
            } else {
                this.setState({
                    currentGrade: level === 10 ? 1 : level + 1
                });
            }
        };

        return (
            <Card>
                <GqlQueryWrapper
                    query={RISK_LEVEL}
                    variables={{ ticker }}
                    dataFunc={riskPotentialUtil}
                >
                    {({ data: { riskLevelName, riskLevel, grade } }) =>
                        !riskLevel ? (
                            <ErrorMessageNewFund
                                cardName={CARD_NAMES.RISK_POTENTIAL}
                            />
                        ) : (
                            <React.Fragment>
                                <TitleWithDescription title="Risk Potential" />
                                <span className="risk-label">
                                    Investment Risk
                                </span>
                                <div className="rrModal">
                                    <span className="risk-label">
                                        {riskLevelName}
                                    </span>
                                    <div className="card-instructions">
                                        See where this fund&#39;s standard
                                        deviation falls on the continuum of
                                        standard deviation ranges of all{' '}
                                        <span className="no-wrap">
                                            T. Rowe Price
                                        </span>{' '}
                                        funds.
                                    </div>
                                    <div className="gradient-container">
                                        <div className="gradient-range">
                                            {/* left gradient arrow */}

                                            <div className="gradient-arrows gradient-arrows-left">
                                                <i
                                                    onClick={() =>
                                                        scrollDir(
                                                            'prev',
                                                            !currentGrade
                                                                ? grade
                                                                : currentGrade
                                                        )
                                                    }
                                                    onKeyPress={() =>
                                                        scrollDir(
                                                            'prev',
                                                            !currentGrade
                                                                ? grade
                                                                : currentGrade
                                                        )
                                                    }
                                                    role="link"
                                                    tabIndex="-1"
                                                >
                                                    <img
                                                        src={chLeft}
                                                        alt=" "
                                                        height="50px"
                                                    />
                                                </i>
                                            </div>
                                            <div className="gradient-image">
                                                <div
                                                    className={`rrGraphRow rrGraphTp rrG-${grade}`}
                                                >
                                                    {' '}
                                                </div>
                                                <div
                                                    className={`rrGraphRow rrGraph rrG-${
                                                        !currentGrade
                                                            ? grade
                                                            : currentGrade
                                                    }`}
                                                >
                                                    {' '}
                                                </div>
                                                <div
                                                    className={`rrGraphRow rrGraphBt rrG-${grade}`}
                                                >
                                                    {' '}
                                                </div>
                                            </div>
                                            {/* */}
                                            {/* right gradient arrow */}
                                            <div className="gradient-arrows text-right">
                                                <i
                                                    onClick={() =>
                                                        scrollDir(
                                                            'next',
                                                            !currentGrade
                                                                ? grade
                                                                : currentGrade
                                                        )
                                                    }
                                                    onKeyPress={() =>
                                                        scrollDir(
                                                            'next',
                                                            !currentGrade
                                                                ? grade
                                                                : currentGrade
                                                        )
                                                    }
                                                    role="link"
                                                    tabIndex="-1"
                                                >
                                                    <img
                                                        src={chRight}
                                                        alt=" "
                                                        height="50px"
                                                    />
                                                </i>
                                            </div>
                                        </div>
                                        <div className="gradient-chart col-xs-8 col-sm-10 text-center">
                                            <div className="risk-labels">
                                                Lower
                                            </div>
                                            <div className="risk-labels">
                                                Moderate
                                            </div>
                                            <div className="risk-labels">
                                                Higher
                                            </div>
                                        </div>
                                    </div>
                                    <div className="risk-potential">
                                        <div className="risk-potential-content">
                                            <p>
                                                This chart displays the relative
                                                risk of each{' '}
                                                <span className="no-wrap">
                                                    T. Rowe Price
                                                </span>{' '}
                                                mutual fund using the fund&#39;s
                                                standard deviation of returns.
                                            </p>
                                            <p>
                                                {getRiskDisclaimer(
                                                    !currentGrade
                                                        ? grade
                                                        : currentGrade
                                                )}{' '}
                                                Use the left and right arrows to
                                                explore the risk spectrum
                                                ranges.{' '}
                                                <a
                                                    id="jumptodisc"
                                                    href={`${
                                                        window.location.pathname
                                                    }#content-disclosures`}
                                                >
                                                    See how we determine
                                                </a>{' '}
                                                where to place funds on the risk
                                                spectrum.
                                            </p>
                                            {trpTickerOverLap.includes(
                                                ticker
                                            ) && (
                                                <p>
                                                    Risk spectrum categories
                                                    overlap; this fund’s
                                                    standard deviation falls in
                                                    the overlap between two risk
                                                    spectrum categories and
                                                    therefore the fund is placed
                                                    so that its risk
                                                    categorization is better
                                                    aligned with anticipated
                                                    return characteristics an
                                                    investor may experience
                                                    going forward at the
                                                    discretion of T. Rowe Price.
                                                </p>
                                            )}
                                        </div>

                                        <div className="view-other-funds">
                                            <a href={`?riskLevel=${riskLevel}`}>
                                                View other funds in this risk
                                                return category
                                                <img
                                                    className="img-chevron-rt"
                                                    src={chRight}
                                                    alt=""
                                                />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )
                    }
                </GqlQueryWrapper>
                <style jsx>{styles}</style>
            </Card>
        );
    }
}

export default RiskPotential;
